import React, { useState, useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

function Gallery() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);

  const handleNavigation = (path) => {
    navigate(path); // Navigate to the specified path
  };

  return (
    <Container>
      <h1 className='shine' data-aos="fade-up">Journey Through Our Lens</h1>

      <Wrap>
        {cardData.map((card, index) => (
          <Card
            key={index}
            background={card.background}
            size={card.size}
            onClick={() => handleNavigation(card.link)} // Add navigation on click
          >
            <Overlay />
            <div className="text">{card.text}</div>
          </Card>
        ))}
      </Wrap>
    </Container>
  );
}

const cardData = [
  { text: "Corporate", background: "url('./Category/corporate.jpg')", size: { width: '30%', height: '300px' }, link: "/corporate-video" },
  { text: "Resort Productions", background: "url('./Category/resort.jpg')", size: { width: '60%', height: '300px' }, link: "/resort-productions" },
  { text: "Real Estate", background: "url('./Category/estate.jpg')", size: { width: '25%', height: '300px' }, link: "/real-state-video-production" },
  { text: "Documentaries", background: "url('./Category/documentaries.jpg')", size: { width: '25%', height: '300px' }, link: "/documentary" },
  { text: "Destination Promotions", background: "url('./Home/05.jpg')", size: { width: '38%', height: '300px' }, link: "/destination-promotional" },
  { text: "Action Sports", background: "url('./Category/sport.jpg')", size: { width: '45%', height: '300px' }, link: "/sports-video" },
  { text: "Product Commercials", background: "url('./Category/commercial.jpg')", size: { width: '45%', height: '300px' }, link: "/product-commercial" },
  { text: "Aerial Cinematography", background: "url('./Category/arial.jpg')", size: { width: '91%', height: '300px' }, link: "/aerial" },
];

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: var(--primary-color);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding: 50px 0;

  @media only screen and (max-width: 1200px) {
    padding: 30px 0;
  }

  h1 {
    font-size: 48px;
    margin: 60px 0;
    color: #ffffff;
    text-transform: uppercase;

    @media only screen and (max-width: 1200px) {
      font-size: 38px;
      text-align: center;
      margin: 30px 10px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 32px;
    }
  }
`;

const Wrap = styled.div`
  width: 95%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  z-index: 2;

  @media only screen and (max-width: 768px) {
    justify-content: flex-start;
  }
`;

const Card = styled.div`
  width: ${(props) => props.size.width};
  height: ${(props) => props.size.height};
  border-radius: 15px;
  background-image: ${(props) => props.background};
  background-size: cover;
  background-position: center;
  position: relative;
  margin: 10px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  /* Shine effect */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -150%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: skewX(-25deg);
    transition: all 0.8s ease-in-out;
  }

  &:hover::before {
    left: 150%;
  }

  .text {
    position: absolute;
    bottom: 20px;
    left: 20px;
    z-index: 2;
    color: #ffffff;
    font-weight: 900;
    font-size: 1.5em;
    text-shadow: 1px 1px 10px rgba(0, 0, 0, 0.7);
  }

  @media only screen and (max-width: 768px) {
    width: 100%; /* Full width on mobile */
    height: 200px; /* Adjust height for smaller screens */
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2); 
  z-index: 1;
  pointer-events: none;
`;

export default Gallery;
